@if (message().IsModerated) {
    <span class="moderated-message"><i class="fa fa-ban" aria-hidden="true"></i> {{ moderatedText }}</span>
} @else {
    {{ message().MessageText }}
}
